import React from "react";
import JobAlertTable from "./components/JobAlertTable";

const JobAlert: React.FC = () => {
  return (
    <div className="">
      <JobAlertTable />
    </div>
  );
};

export default JobAlert;
